import React from "react";
import { Box } from "@mui/material";
import stridistLogo from "../../app/logo.svg";
import placeholderIcon from "../../../assets/demo-appicon.png";
import { ArrowRight } from "lucide-react";
import { useCurrentWorkspace } from "../../../hooks/useCurrentWorkspace";

export function BrandedAppLogoSwitchContent() {
  const { logoUrl } = useCurrentWorkspace();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 2,
        alignItems: "center",
      }}
    >
      <Box
        component={"img"}
        sx={{
          width: 100,
          height: 100,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "20%",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        }}
        src={stridistLogo}
      />
      <ArrowRight size={40} style={{ marginTop: 10 }} />
      <Box
        component={"img"}
        sx={{
          width: 100,
          height: 100,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "20%",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        }}
        src={logoUrl || placeholderIcon}
      />
    </Box>
  );
}
